import { DownOutlined, FolderOpenTwoTone, LoadingOutlined, SaveOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, Row, Spin, Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { Tabs } from 'antd/lib';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { PhanQuyenRequest } from '../../models/quyen/Quyen';
import SearchAccountTable from '../../modules/department/SearchAccountTable';
import { layDSQuyenTheoIdNguoiDung, layDSTatCaQuyen, luuQuyenTheoIdNguoiDung } from '../../services/quyen';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: _item?.id,
                title: _item?.tenQuyen,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const convertDataTreeViewNguoiDung = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data && data != null) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.tenDangNhap == null ? _item?.id.toString() + "_" + _item?.ten : _item?.id,
                title: _item?.ten || _item?.hoTen,
                icon: _item?.tenDangNhap == null ? <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" /> : <UserOutlined style={{ fontSize: "20px", color: "#4096ff" }} rev="" />,
                children: convertDataTreeViewNguoiDung(_item?.children)
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
const PhanQuyen = () => {
    const [openModalSave, setOpenModalSave] = useState<boolean>(false);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);

    const [features, setFeatures] = useState<any>([]);
    const [accountSelected, setAccountSelected] = useState<any>();

    const [selectedPermissionIds, setSelectedPermissionIds] = useState<Array<any>>([]);

    const dispatch = useDispatch();

    const onSave = async () => {
        dispatch(showLoadingScreen());
        var request: PhanQuyenRequest = {
            idNguoiDung: accountSelected.id,
            quyen: selectedPermissionIds
        }

        var rs = await luuQuyenTheoIdNguoiDung(request);
        if (rs) {
            toast.success('Cập nhật quyền cho người dùng thành công');
        }
        else {
            toast.error('Cập nhật quyền cho người dùng không thành công');
        }

        dispatch(hideLoadingScreen());
    }

    const onCheckTree = (checkedKeysValue: any) => {
        setSelectedPermissionIds(checkedKeysValue.checked || []);
    };

    const laydsChucNang = async () => {
        try {
            setLoadingTree(true);
            let data = await layDSTatCaQuyen();
            setFeatures(data);
        } catch (error: any) {
            toast.error(error);
        };
        setLoadingTree(false);
    }

    const onSelectAccount = (account: any) => {
        setAccountSelected(account);
    }

    const loadPermissionsOfAccount = async () => {
        if (!accountSelected?.key) {
            setSelectedPermissionIds([]);
            return;
        }

        setLoadingTree(true);
        try {
            let rs = await layDSQuyenTheoIdNguoiDung(accountSelected.id);
            setSelectedPermissionIds(rs.map(x => x.id));
        } catch (ex: any) {
            toast.error(ex);
        }

        setLoadingTree(false);
    }

    useEffect(() => {
        const permissionTree = convertDataTreeView(features);
        setTreeData(permissionTree);
    }, [features]);

    useEffect(() => {
        loadPermissionsOfAccount();
    }, [accountSelected]);

    useEffect(() => {
        laydsChucNang();
    }, []);

    return (<section>
        <ModalTextForm
            show={openModalSave}
            title="Phân quyền cho người dùng"
            handleClose={() => setOpenModalSave(false)}
            handleSave={async () => {
                await onSave()
                setOpenModalSave(false)
            }}
        >
            <p>Bạn có xác nhận lưu quyền cho người dùng này không?</p>
        </ModalTextForm>
        <ContentHeader title="Phân quyền" />
        <Row gutter={16}>
            <Col span={16}>
                <SearchAccountTable onChange={onSelectAccount} />
            </Col>
            <Col span={8}>
                <Tabs defaultActiveKey="1"
                    tabBarExtraContent=
                    {
                        accountSelected?.id ?
                            <Button
                                type="primary"
                                icon={<SaveOutlined rev="" />}
                                onClick={() => setOpenModalSave(true)}
                            >
                                Lưu
                            </Button> : <></>
                    }
                    items={[{
                        key: '1',
                        label: 'Danh sách quyền',
                        children:
                            <div className="card card-body">
                                <Row>
                                    <Col span="24">
                                        {loadingTree ?
                                            <Spin indicator={antIcon} />
                                            : <div id="treeView">
                                                <Tree
                                                    checkable={accountSelected?.key ? true : false}
                                                    checkedKeys={selectedPermissionIds || []}
                                                    showIcon
                                                    showLine
                                                    multiple
                                                    switcherIcon={<DownOutlined rev="" />}
                                                    treeData={treeData}
                                                    onCheck={onCheckTree}
                                                    autoExpandParent
                                                    blockNode
                                                    checkStrictly
                                                    defaultExpandParent
                                                />
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </div>
                    }
                    ]}
                >
                </Tabs>
            </Col>
        </Row>
    </section>
    );
};

export default PhanQuyen;
